export default "__VITE_ASSET__9e156dca__"